export default __webpack_public_path__ + "static/architecture-m-b6ee58d7b383c5cd0dd9599ca2304dfb.webp";